export const transactionTitles: Record<string, string> = {
  'incentive payment': 'post incentive',
};
